// Imported first in index.tsx, so it runs before any module that calls the APIs while loading
// (core i18n fetches translations at import time, widgets call their APIs on first render).
//
// 1. A login redirect brings the token in ?t=, but AuthAvangardProvider stores it only in an effect
//    after the first render; until then the early calls go out with no token or a stale one.
//    Store it right away.
// 2. A stored token that is not a well-formed JWT (e.g. one from the template's demo login in
//    src/utils/jwt, which uses plain base64) is sent as "Bearer <garbage>" and every API answers
//    401 (IDX14102: Unable to decode the header). Drop it so AuthAvangardProvider sends the user
//    to the login page instead.
const isJwt = (token: string | null): boolean => {
  if (!token) return false;
  const parts = token.split('.');
  if (parts.length !== 3 || parts.some((p) => !/^[A-Za-z0-9_-]+$/.test(p))) return false;
  try {
    const header = JSON.parse(atob(parts[0].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof header === 'object' && header !== null && !!header.alg;
  } catch {
    return false;
  }
};

try {
  const queryToken = new URLSearchParams(window.location.search).get('t');
  if (isJwt(queryToken)) {
    localStorage.setItem('accessToken', queryToken as string);
  } else if (!isJwt(localStorage.getItem('accessToken'))) {
    localStorage.removeItem('accessToken');
  }
} catch {
  // Storage unavailable: AuthAvangardProvider still handles the login redirect
}

export {};
